import React, { Component } from 'react';
import GridCell from './GridCell';

class GridRow extends Component {
  constructor(props) {
    super(props);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  // Handle row click and toggle "isSelected" state
  handleRowClick() {
    if (this.props.onRowClick) {
      this.props.onRowClick(this.props.row.index); // Pass clicked row index & new state
    }
  }

  render() {
    const { columns, row } = this.props;
    return (
      <tr
         className={
        `base-tr 
        ${this.props.isSelected ? 'selected' : ''} 
        ${this.props.group === true ? 'group' : this.props.group === false ? 'new-group' : ''} 
        ${row.isActual === false ? 'expired-row' : ''}`.replace(/\s+/g, ' ')
        }
        onClick={this.handleRowClick}>
        {columns.map((col, index) => (
          <GridCell column={col} row={row} key={index} />
        ))}
      </tr>
    );
  }
}

export default GridRow;


// WEBPACK FOOTER //
// ./src/common/core/grid/GridRow.jsx